// collection
export enum ECollection {
    SW_USERS = 'sw_users',
    SW_COVER_IMG_HOME = 'sw_cover_img_home',
    SW_MAIN_CATEGORIES = 'sw_main_categories',
    SW_SUB_CATEGORIES = 'sw_sub_categories',
    SW_CATEGORIES = 'sw_categories',
    SW_PRODUCTS = 'sw_products',
    SW_MODEL = 'sw_model',
    SW_BRAND = 'sw_brand',
    SW_DESCRIPTIONS = 'sw_descriptions',
    SW_SPECIFICATIONS = 'sw_specifications',
    SW_REVIEWS = 'sw_reviews',
    SW_ADD_TO_CART = 'sw_add_to_cart',
    SW_WISHLIST = 'sw_wishlist',
    SW_TODAY_OFFERS = 'sw_today_offers',
    SW_ORDERS = 'sw_orders',
    SW_RAZORPAY_TRANSACTIONS = 'sw_razorpayTransactions',
    SW_PAYPAL_TRANSACTIONS = 'sw_paypalTransactions',
    SW_TICKETS = 'sw_tickets',
    SW_TICKETS_MESSAGES = 'sw_tickets_messages',

    PINCODES = 'pincodes',
}
